import type { UILabel } from '@broker-as/acquisit-ui-vue/library'
import { labelFor } from '@broker-as/acquisit-ui-vue/library'

export const formatSigningOnBehalfLabel = (label: UILabel, personName: string, onBehalfName: string|null, language?: string|null) => {
	label = String(labelFor(label, language))
	
	let formatted = label.replace(/{on_behalf.name}/g, `<span class="on-behalf-name">${onBehalfName}</span>`)
	                    .replace(/{person.name}/g, `<span class="on-behalf-person-name">${personName}</span>`)
	
	return `<span class="signing-on-behalf-description">${formatted}</span>`
}

/**
 * Extract the filename from a URL
 * @param url - The URL to extract the filename from
 */
export const getFilenameFromUrl = (url: string): string => {
	try {
		const urlObj = new URL(url)
		const pathname = urlObj.pathname
		// Remove leading slash and get last segment
		const segments = pathname.split('/').filter(segment => segment.length > 0)
		return segments.length > 0 ? segments[segments.length - 1] : ''
	} catch (e) {
		// If URL parsing fails (e.g., relative URL), try manual extraction
		// Remove query and fragment
		const withoutQuery = url.split('?')[0]
		const withoutFragment = withoutQuery.split('#')[0]
		const segments = withoutFragment.split('/').filter(segment => segment.length > 0)
		return segments.length > 0 ? segments[segments.length - 1] : ''
	}
}